import React, { useEffect, useState } from "react";
import Gantt, {
  Tasks,
  Column,
  Editing,
  Toolbar,
  Item,
  Validation,
} from "devextreme-react/gantt";
import axios from "axios";
import { API_ROUTE, headersRequest } from "../../helpers";
import _ from "lodash";


const GanttView = (props) => {
  const [dataForGantt, setDataForGantt] = useState([])
  const getTaskForGantt = async (uid,setData) => {
    try {
      const res = await axios.get(
        `${API_ROUTE}product-backlog-gantt-task/${uid}`,
        headersRequest()
      );
      //setTaskForGantt(res.data);
      setData(res.data)

    } catch (error) {
      console.error(error);
    }
  };

  const getHUForGantt = async (uid,setData) => {
    try {
      const res = await axios.get(
        `${API_ROUTE}product-backlog-gantt-hu/${uid}`,
        headersRequest()
      );
      setData(res.data)
    } catch (error) {
      console.error(error);
    }
  };

  const getResourceForGantt = async (uid,setData) => {
    try {
      const res = await axios.get(
        `${API_ROUTE}product-backlog-gantt-resource/${uid}`,
        headersRequest()
      );
      setData(res.data)

    } catch (error) {
      console.error(error);
    }
  };

  const getResourceForGanttTraditional = async (uid,setData) => {
    try {
      const res = await axios.get(
        `${API_ROUTE}product-resources-gantt-traditional/${uid}`,
        headersRequest()
      );
      setData(res.data)
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const actions = [
      {condition : props.dataTask, action : getTaskForGantt},
      {condition : props.dataHu, action : getHUForGantt},
      {condition : props.dataResource, action : getResourceForGantt},
      {condition : props.dataResourceTraditional, action : getResourceForGanttTraditional}
    ]
     actions.forEach(({condition,action})=>{
      if(condition){
        action(props.uid,setDataForGantt)
        
      }
     })
  }, [props.view]);

  const custom_progress_test = (cellInfo) => {
    const getValueProgress = (cellInfo) => {
      switch (cellInfo.value) {
        case 0:
          return "To Do";
        case 100:
          return "Done";
        default:
          return "Doing";
      }
    };

    return getValueProgress(cellInfo);
  };

  const custom_progress_traditional = (cellInfo)=>{
    console.log(cellInfo)
    return `${cellInfo.value} %`
  }
  return (
    <>
    {!props.notTitle && 
      <h5 className="ml-5">
        {" "}
        Timeline {props.dataTask ? "Sprints" :props.dataHu ? " Historias de Usuario" : "Recursos"} :{" "}
      </h5>
      }
      <Gantt
        taskListWidth={500}
        scaleType="weeks"
        height={500}
        onTaskDblClick={() => {
          return console.log("clickOnTask");
        }}
      >
        <Tasks
        dataSource={dataForGantt} 
        />


        <Toolbar>
          <Item name="collapseAll" />
          <Item name="expandAll" />
          <Item name="separator" />
          <Item name="zoomIn" />
          <Item name="zoomOut" />
        </Toolbar>

        <Column dataField="title" caption="Nombre Actividad" minWidth={200} alignment="left" />
        <Column dataField="start" caption="Fecha Inicio" minWidth={80} alignment="right" />
        <Column dataField="end" caption="Fecha Fin" minWidth={80} alignment="right" />
        <Column 
          dataField="progress" 
          caption={ props.dataResourceTraditional? "Progreso":"Estado"} 
          width={80}
          customizeText={ props.dataResourceTraditional? custom_progress_traditional : custom_progress_test}
          alignment="right" />
        <Validation autoUpdateParentTasks /> 
        <Editing disabled />
      </Gantt>
    </>
  );
};

export default GanttView;
